import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangeControlTransitionDetails } from '../models/change-control-transition-details';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../../../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root',
})
export class ChangeControlAuditService {
  constructor(private httpClient: HttpClient) {}

  getChangeControlTransitionDetails = (
    number: string
  ): Observable<ChangeControlTransitionDetails> => {
    return this.httpClient.get<ChangeControlTransitionDetails>(
      ApiConstants.ChangeControl_Transition_Details_Api.replace(
        '{number}',
        number
      )
    );
  };
}
